var React = require('react');

function Points (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 10L10 5L15 10L10 15L5 10Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M18.3687 9.07936L10.9212 1.63061C10.6769 1.38673 10.3458 1.24976 10.0006 1.24976C9.6554 1.24976 9.3243 1.38673 9.07998 1.63061L1.63061 9.07936C1.38673 9.32368 1.24976 9.65478 1.24976 9.99998C1.24976 10.3452 1.38673 10.6763 1.63061 10.9206L9.07936 18.3694C9.32368 18.6132 9.65478 18.7502 9.99998 18.7502C10.3452 18.7502 10.6763 18.6132 10.9206 18.3694L18.3694 10.9206C18.6132 10.6763 18.7502 10.3452 18.7502 9.99998C18.7502 9.65478 18.6132 9.32368 18.3694 9.07936H18.3687ZM9.99998 17.5225L2.47811 9.99998L9.99998 2.47748L17.5225 9.99998L9.99998 17.5225Z","fill":"currentColor","key":1})]);
}

Points.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Points;

Points.default = Points;
